
import { useEffect, useState } from "react"
import { LatestIdeaCard } from "../../components/latestIdeaCard/latestIdeaCard.component"
import { NoIdeaFound } from "../../components/noIdeaFound/noIdeaFound.component"
import { getlatestIdeas } from "../../services/ideas.service"
export const LatestIdeasList = () => {
    const [latestIdeas, setLatestIdeas] = useState([])
    const getlatestIdeasData = async () => {
        const { status, data } = await getlatestIdeas()
        if (status == 200) {
            setLatestIdeas(data)
        }
    }

    useEffect(() => {
        getlatestIdeasData()
    }, [])
    return (
        <>
            {latestIdeas.length ? latestIdeas.map((idea, index) => {
                return (
                    <LatestIdeaCard key={index} empName={idea.EMP_NAME} createdAt={idea.createdAt} upvotes={idea.likes + idea.hearts} desc={idea.IDEA_DETAIL}/>
                )
            }) : <NoIdeaFound heading={"No Latest Ideas Found"} />}

        </>
    )

    return (
        <div className="col-12 col-lg-3">
            <div className="card">
                <div className="card-body h-200p">
                    <div className="media">
                        <div className="starshot-ring mr-1">
                            <div className="avatar">
                                <div className="text-icon font-lato">D</div>
                            </div>
                        </div>
                        <div className="media-body my-auto">
                            <p className="mb-0 font-lato">DEEPAK</p>
                            <p className="mb-0 font-lato font-10 star-orange">2 months ago</p>
                        </div>
                    </div>
                    <div className="mt-1">
                        <p className="text-starshot font-lato">0 upvotes</p>
                    </div>
                </div>
            </div>
        </div>

    )
}